/**
 * Constants used by the coordinate batch save operation.
 *
 * Centralizes all configuration values for batch processing of coordinate changes,
 * including concurrency limits, fallback values, S3 paths, and image processing settings.
 *
 * @property MAX_CONCURRENT_ITEMS - Maximum number of items to process simultaneously (prevents resource exhaustion)
 * @property PAGE_FALLBACK - Default page number when coordinate page is undefined
 * @property UNKNOWN_FLYER_ITEM_LIST_ID - Fallback ID for file naming when flyer item list ID is missing
 * @property CROPPED_IMAGE_FILENAME_PREFIX - Prefix for cropped image filenames
 * @property UNKNOWN_MERCHANT - Fallback merchant name for S3 path construction
 * @property DATE_RANGE_FALLBACK - Fallback date range string for S3 path when dates are missing
 * @property S3_PATH_PREFIX - Base S3 path for storing auto-coordinate flyer images
 * @property IMAGE_PROCESSING.RESIZE_SMALL - Whether to create small thumbnails for product images
 * @property IMAGE_PROCESSING.SPLIT_LARGE_IMAGE - Whether to split large images into smaller chunks
 */
export const COORDINATE_BATCH_SAVE_CONSTANTS = {
  MAX_CONCURRENT_ITEMS: 3,
  PROGRESS_UPDATE_INTERVAL: 10,
  PAGE_FALLBACK: 0,
  UNKNOWN_FLYER_ITEM_LIST_ID: "unknown",
  CROPPED_IMAGE_FILENAME_PREFIX: "flyer-item-cropped",
  UNKNOWN_MERCHANT: "unknown-merchant",
  DATE_RANGE_FALLBACK: "no-date-range",
  S3_PATH_PREFIX: "auto-coordinates/flyer",
  IMAGE_PROCESSING: {
    RESIZE_SMALL: true,
    SPLIT_LARGE_IMAGE: false,
  },
};
